type ReplaceImageResponse = {
  message: string;
  bucket: string;
  key: string;
  contentType: string;
};

export async function replaceImageInS3Only(
  imageId: string,
  file: File,
  accessToken?: string
): Promise<ReplaceImageResponse> {
  if (!file) throw new Error("Replacement file is required.");

  const formData = new FormData();
  formData.append("file", file);

  const response = await fetch(
    `${process.env.REACT_APP_GOFLYER_API_END_POINT}/admin-image/${imageId}/replace-image`,
    {
      method: "POST",
      headers: {
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      },
      body: formData,
      credentials: "include",
    }
  );

  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(
      `Image replace failed (${response.status}): ${
        text || response.statusText
      }`
    );
  }

  return (await response.json()) as ReplaceImageResponse;
}
